import { EventEmitter } from "./EventEmitter";

/**
 * Класс для работы с свг планами секторов, стадионов, сцен ...
 * инициализирует интерактивность и предоставляет события (click, hover ...)
 */
export class InteractPlan {
  /**
   * В конструктор можем передавать параметры для интерактива
   * тогда инициализация произойдет сразу, также можно вызывать через init
   * @param params {Object} - Параметры интерактива: {
   *   svg,
   *   addViewBox {Boolean},
   *   dragging {Boolean},
   *   addControls {Boolean},
   * }
   */
  constructor(params = {}) {
    this.svg = null;
    this.interact = null;
    
    this.interactEmitter = new EventEmitter();
  
    /* Свойства (состояния) для плана */
    this.svgState = {
      x: 0,
      y: 0,
      currentScale: 1,
    };
    
    /* Если передать параметры при объявлении то инциализировать интерактивность */
    if (this.isValidParams(params)) this.init(params);
  }
  
  /**
   * Инициализация интерактива
   * @param params {Object} - Параметры (описание в конструкторе)
   */
  init(params) {
    if (!this.isValidParams(params)) throw new Error("Не удалось получить параметры интерактива!");
    
    this.svg = this.getSvgFromParams(params);
    
    if (!this.svg) throw new Error("Не удалось получить SVG!");
    
    this.interact = interact(this.svg);
    
    /* Инициализация доп параметров */
    if (params.addViewBox !== false) this.setViewBox();
    if (params.dragging !== false) this.initDragging();
    if (params.addControls !== false) this.initControls();
    
    this.initDragMoving();
    this.initTapping();
    this.initHovering();
  }
  
  isValidParams(params) {
    if (!(typeof params === 'object' && params !== null)) return false;
    if (!params.svg && !params.length > 0) return false;
    
    return true;
  }
  
  getSvgFromParams(params) {
    if (params.svg && params.svg.length > 0) return params.svg[0];
    if ($.contains(document, params[0])) return params[0];
    
    return null;
  }
  
  /* Listeners */
  on(action, fn) {
    if (action === "tap") {
      this.interactEmitter.subscribe("event:tap-on-plan", target => {
        fn(target);
      });
    }
    if (action === "hover") {
      this.interactEmitter.subscribe("event:hover-on-plan", target => {
        fn(target);
      });
    }
  }
  
  /* Инициализация базового интерактива */
  initDragging() {
    this.interact.draggable({
      modifiers: [
        interact.modifiers.snap({
          targets: [interact.createSnapGrid({ x: 10, y: 10 })],
          range: Infinity,
          relativePoints: [{ x: 0, y: 0 }],
        }),
        interact.modifiers.restrict({
          restriction: this.svg.parentNode,
          elementRect: { top: 0, left: 0, bottom: 1, right: 1 },
          endOnly: true,
        }),
      ],
      inertia: true,
    });
  }
  
  initDragMoving() {
    this.interact.on("dragmove", event => {
      this.svgState.x += event.dx;
      if (this.svgState.currentScale !== 1) this.svgState.y += event.dy;
      this.updateTransformOfPlan();
    });
  }
  
  initControls() {
    $("#js-plan-zoom-in").on("click", () => {
      this.svgState.currentScale += 0.2;
      this.updateTransformOfPlan();
    });
    $("#js-plan-zoom-out").on("click", () => {
      this.svgState.currentScale -= 0.2;
      if (this.svgState.currentScale <= 0.5) this.svgState.currentScale = 0.5;
      this.updateTransformOfPlan();
    });
    $("#js-plan-zoom-reset").on("click", () => {
      this.svgState.x = 0;
      this.svgState.y = 0;
      this.svgState.currentScale = 1;
      this.updateTransformOfPlan();
    });
  }
  
  initHovering() {
    $(this.svg.parentNode).on("mouseover", e => {
      this.interactEmitter.emit("event:hover-on-plan", $(e.target));
    });
  }
  
  initTapping() {
    this.interact.on("tap", event => {
      if (event.which === 3) return false;
      
      this.interactEmitter.emit("event:tap-on-plan", $(event.target));
      
      event.stopPropagation();
      event.stopImmediatePropagation();
      event.preventDefault();
    });
  }
  
  /* Helpers */
  updateTransformOfPlan(event) {
    return (this.svg.style.webkitTransform = this.svg.style.transform =
        "translate(" +
        this.svgState.x +
        "px, " +
        this.svgState.y +
        "px)" +
        "scale(" +
        this.svgState.currentScale +
        ")");
  }
  
  /** Адаптирует план добавив новый атрибут */
  setViewBox() {
    if ($(this.svg).attr("viewBox")) return true;
    
    return $(this.svg).attr(
        "viewBox",
        `0 0 ${$(this.svg).attr("width")} ${$(this.svg).attr("height")}`
    );
  }
  
}